module.exports = __webpack_public_path__ + "static/media/nault.d8f4b4fe.ico";